import { render, staticRenderFns } from "./LeadButton.vue?vue&type=template&id=21987f8b&"
import script from "./LeadButton.vue?vue&type=script&lang=js&"
export * from "./LeadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports